import { useNavigate } from "react-router-dom";

const Section10 = () => {
    const navigate = useNavigate();

    const termPage = () => {
        navigate("/Terms");
    };

    const privacyPage = () => {
        navigate("/Privacy");
    };

    // ✅ Dynamic year
    const currentYear = new Date().getFullYear();

    return (
        <div className="bg-grey pl-[12%] pr-[3%] py-[2%] flex max-sm:flex max-sm:text-center max-sm:items-center" id="s10">
            
            {/* Desktop */}
            <p className="w-[50%] max-sm:hidden">
                Copyright © {currentYear} Sri Raghunath JI Overseas. All Right Reserved.
            </p>

            <div className="w-[50%] flex justify-end max-sm:hidden">
                <p className="pr-10">
                    <span
                        className="cursor-pointer hover:text-red hover:underline"
                        onClick={termPage}
                    >
                        Terms & Conditions
                    </span>
                </p>
                <p>
                    <span
                        className="cursor-pointer hover:text-red hover:underline"
                        onClick={privacyPage}
                    >
                        Privacy Policy
                    </span>
                </p>
            </div>

            {/* Mobile */}
            <p className="hidden max-sm:block">
                Copyright © {currentYear} Sri Raghunath JI Overseas. All Right Reserved.{" "}
                <span
                    className="cursor-pointer hover:text-red hover:underline"
                    onClick={termPage}
                >
                    Terms & Conditions
                </span>{" "}
                .{" "}
                <span
                    className="cursor-pointer hover:text-red hover:underline"
                    onClick={privacyPage}
                >
                    Privacy Policy
                </span>
            </p>
        </div>
    );
};

export default Section10;